import {FieldsManager} from '../../../data/services/fields';
import {chargeToClearedValues, chargeToFieldState} from './charge-to';

/**
 * Apply a charge-to choice to a Field map: set the discriminator, blank the FKs the choice
 * does not point at, and show/require the one it does.
 *
 * Split from charge-to.js because it needs FieldsManager, whose import chain
 * (localStorage -> util-helpers -> util-constants) throws under vitest. The rules live in
 * charge-to.js and are tested there; this is the plumbing that applies them.
 *
 * Fields absent from a surface are skipped — invoice and recurring lines have no
 * ChargeToTruckID.
 */
export function applyChargeTo(fields, chargeTo, options = {}) {
    let updated = FieldsManager.updateField(fields, 'ChargeTo', Number(chargeTo));

    Object.entries(chargeToClearedValues(chargeTo)).forEach(([name, value]) => {
        if (updated[name]) {
            updated = FieldsManager.updateField(updated, name, value);
        }
    });

    Object.entries(chargeToFieldState(chargeTo, options)).forEach(([name, state]) => {
        if (!updated[name]) {
            return;
        }
        updated[name].type = state.type;
        updated[name].validate = state.validate;
        updated[name].errorMessage = '';
    });

    return updated;
}
